module.exports = __webpack_public_path__ + "static/media/dismorfobia.f8517500.png";